import React from 'react';
import CalendlyModal from './CalendlyModal';
import SoftwareInterestModal from './SoftwareInterestModal';
import { useModal } from '../contexts/ModalContext';

const GlobalModals: React.FC = () => {
  const {
    isInterestModalOpen,
    isCalendlyModalOpen,
    handleInterestYes,
    handleInterestNo,
    handleCalendlyClose,
    handleInterestModalClose,
  } = useModal();

  return (
    <>
      {/* Software Interest Modal */}
      <SoftwareInterestModal
        isOpen={isInterestModalOpen}
        onClose={handleInterestModalClose}
        onYes={handleInterestYes}
        onNo={handleInterestNo}
      />

      {/* Calendly Modal */}
      <CalendlyModal
        isOpen={isCalendlyModalOpen}
        onClose={handleCalendlyClose}
        url="https://calendly.com/zylusales/group-growth-consultation?hide_gdpr_banner=1"
        title="Schedule Your Free Consultation"
      />
    </>
  );
};

export default GlobalModals;
